<div class="content-loaf">
  <div *ngIf="isSaikiTubeReferenceUser">
    <app-saikitubereference></app-saikitubereference>
  </div>

  <div *ngIf="isVacantBedsReferenceUser">
    <div class="content-loaf">
      <h2>情報参照</h2>
      <hr />

      <div class="row content-block">
        <div class="col-12">
          <p>ボタンをクリックするとそれぞれの情報を参照できます。</p>

          <a name="vacant-bed-reference-link" class="btn btn-primary btn-primary-gradient layout-btn" routerLink="/vacantbedreference">空床情報参照</a>

          <a class="btn btn-primary btn-primary-gradient layout-btn" href="../pdf/MembersOnly/rinban.pdf" target="_blank">検案輪番表</a>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isVacantBedsReferenceUser">
    <div class="content-loaf">
      <h2>文書</h2>
      <hr />
      <div class="row content-block">
        <div class="col-12 col-md-8 col-lg-12">
          <a class="btn btn-primary btn-primary-gradient layout-btn" href="https://1drv.ms/f/c/5d1868ea73f256b0/ErBW8nPqaBgggF1uAAAAAAABA7qgDDE5V3VWGU4V75U3oA?e=8rbJHW" target="_blank">文書のお知らせ</a>
          <a class="btn btn-primary btn-primary-gradient layout-btn" href="https://1drv.ms/f/c/5d1868ea73f256b0/ErBW8nPqaBgggF2bAAAAAAABHjYrnD3e5u7F4kxanIQ15A?e=hbEqRA" target="_blank">日医FAXﾆｭｰｽ</a>
          <a class="btn btn-primary btn-primary-gradient layout-btn" href="https://1drv.ms/f/c/5d1868ea73f256b0/ErBW8nPqaBgggF1BAwAAAAABUnSXiIGS8BXLsOoK6JwiuA?e=g7NAF5" target="_blank">医師会会報</a>
          <a class="btn btn-primary btn-primary-gradient layout-btn" href="https://1drv.ms/f/c/5d1868ea73f256b0/ErBW8nPqaBgggF1RAwAAAAABihFlhf6dHY2GlAAZLYoZcQ?e=0eNzIH" target="_blank">医師会会誌</a>
        </div>
      </div>
    </div>

    <app-membersnewsreference></app-membersnewsreference>
  </div>

  <div *ngIf="isVacantBedsEditUser">
    <app-vacantbededit></app-vacantbededit>
  </div>

  <div *ngIf="isAdmin">
    <app-saikitubeedit></app-saikitubeedit>

    <app-membersnewsedit></app-membersnewsedit>

    <app-disaster-manage></app-disaster-manage>
  </div>
</div>

<iframe src="../Counter/count.php" style="display: none;"></iframe>
